/**
 * Meta Pixel helper — fires standard events for SPA route changes and conversions.
 * Pixel ID: 1202868801768497 (loader lives in index.html).
 *
 * Consent gating: we do NOT call `fbq('init', ...)` until the visitor accepts
 * analytics cookies (see components/CookieConsentBanner.jsx). Every helper
 * method here is a no-op when consent is missing.
 */

const PIXEL_ID = '1202868801768497';
export const CONSENT_KEY = 'gospeleon.cookieConsent';
export const CONSENT_EVENT = 'cookie-consent-changed';
let initialized = false;

export function hasAnalyticsConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    if (raw === 'all') return true;
    if (raw === 'necessary') return false;
    const parsed = JSON.parse(raw);
    return !!parsed.analytics;
  } catch {
    return false;
  }
}

function fbq(...args) {
  if (!initialized || typeof window === 'undefined' || !window.fbq) return;
  window.fbq(...args);
}

/**
 * Initialize the pixel and fire the first PageView. Safe to call repeatedly —
 * it's idempotent. Called once from App.js on mount, and again when consent
 * is granted via the cookie banner.
 */
export function initPixelIfConsented() {
  if (initialized) return;
  if (!hasAnalyticsConsent()) return;
  if (typeof window === 'undefined' || !window.fbq) return;
  try {
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    initialized = true;
  } catch {
    // swallow — analytics must never break the app
  }
}

export const MetaPixel = {
  pageView: () => fbq('track', 'PageView'),

  addToCart: (item) => fbq('track', 'AddToCart', {
    content_name: item.title,
    content_type: item.item_type || 'product',
    content_ids: [item.item_id],
    value: item.price,
    currency: 'NGN',
  }),

  purchase: (total, items = []) => fbq('track', 'Purchase', {
    value: total,
    currency: 'NGN',
    content_ids: items.map(i => i.item_id || i.item_type),
    content_type: 'product',
    num_items: items.length,
  }),

  subscribe: (plan, value) => fbq('track', 'Subscribe', {
    value,
    currency: 'NGN',
    predicted_ltv: value * 12,
    content_name: plan,
  }),

  search: (query) => fbq('track', 'Search', { search_string: query }),

  viewContent: (item) => fbq('track', 'ViewContent', {
    content_name: item.title,
    content_type: item.type || 'product',
    content_ids: [item.id],
  }),
};
